<div class="footer-main content-web-section" id="pop-up-content">
    <div class="inner-footer-container">
        <div class="popup-section">
            <div class="pop-up-icon text-center cursor-pointer">
                <span (click)="setPopUp(true)" *ngIf="!showPopUp">
                    <span class="pop-up-icon-text">Let us help you</span> &nbsp;
                    <img class="icn-img" src="assets/icons/up_white_arrow.png">
                </span>
                <span (click)="setPopUp(false)" *ngIf="showPopUp">
                    <span class="pop-up-icon-text">Let us help you</span> &nbsp;
                    <img class="icn-img" src="assets/icons/down_white_arrow.png">
                </span>

            </div>
            <div class="pop-up-content " *ngIf="showPopUp">
                <form name="form" (ngSubmit)="f.form.valid && submitContactDetails(f)" #f="ngForm" novalidate>
                    <div class="pop-up-data ">
                        <span class="pop-up-heading">Please provide your contact details to assist you better in your
                            investment journey</span>

                        <div class="col-lg-12 pt-2 row">
                            <div class="col-lg-6 full-name">
                                <label for="fullName" class="lbl-text">Full Name</label><br>
                                <input type="text" id="fullName" [pattern]="alphaPattern" minlength="1" maxlength="32"
                                    [(ngModel)]="userData.name" name="fname" #fname="ngModel" autocomplete="off"
                                    required>
                                <div *ngIf="f.submitted && fname.invalid" class="error-text-footer">
                                    <div *ngIf="fname.errors?.['required']">Full Name is required</div>
                                    <div *ngIf="fname.errors?.['pattern']">Name not valid.</div>
                                </div>
                            </div>
                            <div class="col-lg-6 mobile-number">
                                <label for="mobile" class="lbl-text">Mobile</label><br>
                                <input type="text" class="mobText" minlength="14" (keypress)="numberOnly($event)"
                                    maxlength="14" [pattern]="mobNumberPattern" id="mobile"
                                    [(ngModel)]="userData.phoneNum" autocomplete="off" name="mobile" #mobile="ngModel"
                                    required>
                                <div *ngIf="f.submitted && mobile.invalid" class="error-text-footer">
                                    <div *ngIf="mobile.errors?.['required']">Mobile number required</div>
                                    <div *ngIf="mobile.errors?.['pattern']">Mobile number not valid.</div>
                                </div>
                            </div>
                        </div>

                        <span class="help-footer-text">By entering your details, you hereby authorize ITI Mutual
                            Fundand/or its authorized service
                            provider(s) to contact you and this will override any NDNC registration made by
                            you.</span><br><br>
                        <button type="submit" class="submit-button">Submit</button>
                        <br><br>
                    </div>
                </form>

            </div>
        </div>
        <div class="footer-content ">
            <img src="assets/icons/bac_ to_top.png" class="cursor-pointer to-top pull-right" (click)="gotoTop()">
            <div class="col-12 row footer-content-col">
                <div class="col-2  space-section"></div>
                <div class="col-8  link-section">
                    <div class="col-12 row footer-link-section">
                        <div class="col-3">
                            <span class="footer-section-heading"> Key Policies</span>
                            <uL class="footer-links">
                                <li class="cursor-pointer" *ngFor="let item of footerLinks?.keyPolicies"
                                    (click)="navFooterLink(item.url)">{{item.displayName}}</li>
                            </uL>

                        </div>
                        <div class="col-3">
                            <span class="footer-section-heading"> Quick links</span>
                            <uL class="footer-links">
                                <li class="cursor-pointer" (click)="accountStatements()">Account Statements</li>
                                <li class="cursor-pointer" *ngFor="let item of footerLinks?.quickLinks"
                                    (click)="navFooterLink(item.url)">{{item.displayName}}</li>
                                <li class="cursor-pointer" (click)="digitalKyc()">Digital KYC</li>
                                <li class="cursor-pointer"(click)="ARNHardcodedLink()">ARN Hardcoded Link</li>
                                <li class="cursor-pointer"(click)="externalLink('MITRA')">MITRA Platform</li>
                                <li class="cursor-pointer"(click)="externalLink('KYC')">Update KYC</li>
                            </uL>

                        </div>
                        <div class="col-3">
                            <span class="footer-section-heading"> External Links</span>
                            <uL class="footer-links">
                                <li class="cursor-pointer" *ngFor="let item of footerLinks?.otherLinks"
                                    (click)="viewWebsite(item.url)">{{item.displayName}}</li>
                            </uL>

                        </div>
                        <div class="col-3">
                            <span class="footer-section-heading"> Help</span>
                            <uL class="footer-links">
                                <li class="cursor-pointer" *ngFor="let item of footerLinks?.HelpLinks"
                                    (click)="openHelpers(item.url)">{{item.displayName}}</li>
                            </uL>

                        </div>

                    </div>
                    <div class="col-12 copy-right">
                        © {{date| date:'yyyy'}} ITI Mutual Fund. All rights reserved
                        <p class="browser-compatibility-text">
                            Site best viewed in Chrome v85 +, Firefox v82 +, Safari v14 +, Microsoft Edge v85 +
                            browsers.
                        </p>
                        <hr class="footer-hr">
                    </div>
                    <br> <br> <br>
                    <div class="col-12 row">
                        <div class="contact-infos col-6">
                            <i class="fa fa-envelope footer-icon" aria-hidden="true"></i> &nbsp;&nbsp; <a
                                class="footer-icon-text footer-icon-text-border" href="mailto:mfassist@itiorg.com">
                                mfassist&#64;itiorg.com</a>
                            <i class="fa fa-phone footer-icon footer-icon2" aria-hidden="true"></i>&nbsp;&nbsp;<a
                                class="footer-icon-text" href="tel:1800-266-9603"> 1800-266-9603</a>

                        </div>
                        <div class="social-media-iconss col-6 align-h">
                            <div class="footer-social-share-text">Follow Us On: </div>
                            <div>
                                <img src="assets/icons/icon_fb.png" class="cursor-pointer "
                                    (click)="viewWebsite('https://m.facebook.com/ITIMutualFund/')"> &nbsp;
                                <img src="assets/ITI-IAP-HTML/images/X.png" class="cursor-pointer"
                                    (click)="viewWebsite('https://twitter.com/itimutualfund?lang=en')">&nbsp;
                                <img src="assets/icons/icon_youtube.png" class="cursor-pointer"
                                    (click)="viewWebsite('https://www.youtube.com/channel/UCpWl987-i9dvbfiTOLQIleQ')">&nbsp;
                                <img src="assets/icons/icon_insta.png" class="cursor-pointer"
                                    (click)="viewWebsite('https://www.instagram.com/iti.mutualfund/?igshid=uaoiy8hqltnq')">&nbsp;
                                <img src="assets/ITI-IAP-HTML/images/Indeed.png" class="cursor-pointer footer-social-media" (click)="viewWebsite('https://www.linkedin.com/company/iti-mutual-fund/')">&nbsp;
                            </div>
                        </div>

                    </div>

                </div>
                <div class="col-2   space-section"></div>

            </div>
        </div>

        <p class="text-center market-risks" [ngStyle]="{'padding-bottom': flag ? '50px' : '0px'}"> Mutual Fund
            investments are subject to market risks, read all scheme related documents carefully. </p>
    </div>
</div>




<div class="footer-main footer-main-mobile content-mobile-section" id="pop-up-content">
    <div class="popup-section">
        <div class="pop-up-icon text-center cursor-pointer">
            <span (click)="setPopUp(true)" *ngIf="!showPopUp">
                <span class="pop-up-icon-text">Let us help you </span>
                <img class="icn-img" src="assets/icons/up_white_arrow.png">
            </span>
            <span (click)="setPopUp(false)" *ngIf="showPopUp">
                <span class="pop-up-icon-text">Let us help you </span>
                <img class="icn-img" src="assets/icons/down_white_arrow.png">
            </span>

        </div>
        <div class="pop-up-content " *ngIf="showPopUp">
            <form name="form" (ngSubmit)="f.form.valid && submitContactDetails(f)" #f="ngForm" novalidate>
                <div class="pop-up-data ">
                    <br><br> <span class="pop-up-heading">Please provide your contact details to assist you better in
                        your investment journey</span><br><br>

                    <div class="col-lg-12 row">
                        <div class="col-lg-6">
                            <label for="fullName" class="lbl-text">Full Name</label><br>
                            <input type="text" id="fullName" [pattern]="alphaPattern" minlength="1" maxlength="32"
                                [(ngModel)]="userData.name" name="fname" #fname="ngModel" autocomplete="off" required>
                            <div *ngIf="f.submitted && fname.invalid" class="error-text-footer">
                                <div *ngIf="fname.errors?.['required']">Full Name is required</div>
                                <div *ngIf="fname.errors?.['pattern']">Name not valid.</div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <label for="mobile" class="lbl-text">Mobile</label><br>
                            <input type="text" class="mobText" minlength="14" (keypress)="numberOnly($event)"
                                maxlength="14" [pattern]="mobNumberPattern" id="mobile" [(ngModel)]="userData.phoneNum"
                                autocomplete="off" name="mobile" #mobile="ngModel" required>
                            <div *ngIf="f.submitted && mobile.invalid" class="error-text-footer">
                                <div *ngIf="mobile.errors?.['required']">Mobile number required</div>
                                <div *ngIf="mobile.errors?.['pattern']">Mobile number not valid.</div>
                            </div>
                        </div>
                    </div>

                    <br><br>
                    <span class="help-footer-text">By entering your details, you hereby authorize ITI Mutual Fundand/or
                        its authorized service
                        provider(s) to contact you and this will override any NDNC registration made by
                        you.</span><br><br>
                    <button type="submit" class="submit-button">Submit</button>
                    <br><br>
                </div>
            </form>

        </div>
    </div>
    <div class="footer-content ">
        <div class="col-lg-12 row footer-content-col">
            <div class="col-lg-2 space-section"></div>
            <div class="col-lg-8 link-section">
                <div class="col-lg-12 row footer-link-section">
                    <div class="col-lg-3 footer-link-line">
                        <span class="footer-section-heading" (click)="setActive(1)"> Key Policies
                            <span class="footer-arrow">
                                <img src="assets/icons/down_white_arrow.png" class="img-arrow" *ngIf="activeId!==1">
                                <img src="assets/icons/up_white_arrow.png" class="img-arrow" *ngIf="activeId===1">
                            </span>
                        </span>
                        <uL class="footer-links" *ngIf="activeId===1">
                            <li class="cursor-pointer" *ngFor="let item of footerLinks?.keyPolicies"
                                (click)="navFooterLink(item.url)">{{item.displayName}}</li>
                        </uL>

                    </div>
                    <div class="col-lg-3 footer-link-line">
                        <span class="footer-section-heading" (click)="setActive(2)"> Quick links
                            <span class="footer-arrow">
                                <img src="assets/icons/down_white_arrow.png" class="img-arrow" *ngIf="activeId!==2">
                                <img src="assets/icons/up_white_arrow.png" class="img-arrow" *ngIf="activeId===2">
                            </span>
                        </span>
                        <uL class="footer-links" *ngIf="activeId===2">
                            <li class="cursor-pointer" (click)="accountStatements()">Account Statements</li>
                            <li class="cursor-pointer" *ngFor="let item of footerLinks?.quickLinks"
                                (click)="navFooterLink(item.url)">{{item.displayName}}</li>
                            <li class="cursor-pointer" (click)="digitalKyc()">Digital KYC</li>
                            <li class="cursor-pointer" (click)="externalLink('KYC')">Update KYC</li>
                        </uL>

                    </div>
                    <div class="col-lg-3 footer-link-line">
                        <span class="footer-section-heading" (click)="setActive(3)"> External Links
                            <span class="footer-arrow">
                                <img src="assets/icons/down_white_arrow.png" class="img-arrow" *ngIf="activeId!==3">
                                <img src="assets/icons/up_white_arrow.png" class="img-arrow" *ngIf="activeId===3">
                            </span>
                        </span>
                        <uL class="footer-links" *ngIf="activeId===3">
                            <li class="cursor-pointer" *ngFor="let item of footerLinks?.otherLinks"
                                (click)="viewWebsite(item.url)">{{item.displayName}}</li>
                        </uL>

                    </div>
                    <div class="col-lg-3 footer-link-line">
                        <span class="footer-section-heading" (click)="setActive(4)"> Help
                            <span class="footer-arrow">
                                <img src="assets/icons/down_white_arrow.png" class="img-arrow" *ngIf="activeId!==4">
                                <img src="assets/icons/up_white_arrow.png" class="img-arrow" *ngIf="activeId===4">
                            </span>
                        </span>
                        <uL class="footer-links" *ngIf="activeId===4">
                            <li class="cursor-pointer" *ngFor="let item of footerLinks?.HelpLinks"
                                (click)="openHelpers(item.url)">{{item.displayName}}</li>
                        </uL>

                    </div>

                </div>

                <br>
                <div class="col-lg-12 row">
                    <div class="contact-infos col-lg-12">
                        <i class="fa fa-envelope footer-icon" aria-hidden="true"></i> &nbsp;&nbsp; <a
                            class="footer-icon-text footer-icon-text-border" href="mailto:mfassist@itiorg.com">
                            mfassist&#64;itiorg.com</a>
                        <i class="fa fa-phone footer-icon footer-icon2" aria-hidden="true"></i>&nbsp;&nbsp;<a
                            class="footer-icon-text" href="tel:1800-266-9603"> 1800-266-9603</a>

                    </div>


                    <div class="social-media-iconss col-lg-12 text-center">
                        <div class="footer-social-share-text margin-bottom-15">Follow Us On: </div>
                        <div>
                            <img src="assets/icons/icon_fb.png" class="cursor-pointer footer-social-media"
                                (click)="viewWebsite('https://m.facebook.com/ITIMutualFund/')"> &nbsp;
                            <img src="assets/ITI-IAP-HTML/images/X.png" class="cursor-pointer footer-social-media"
                                (click)="viewWebsite('https://twitter.com/itimutualfund?lang=en')">&nbsp;
                            <img src="assets/icons/icon_youtube.png" class="cursor-pointer footer-social-media"
                                (click)="viewWebsite('https://www.youtube.com/channel/UCpWl987-i9dvbfiTOLQIleQ')">&nbsp;
                            <img src="assets/icons/icon_insta.png" class="cursor-pointer footer-social-media"
                                (click)="viewWebsite('https://www.instagram.com/iti.mutualfund/?igshid=uaoiy8hqltnq')">&nbsp;
                                <img src="assets/ITI-IAP-HTML/images/Indeed.png" class="cursor-pointer footer-social-media" (click)="viewWebsite('https://www.linkedin.com/company/iti-mutual-fund/')">&nbsp;
                        </div>
                    </div>
                    <div class="align-h margin-left-25">
                        <div class="stretch copy-right text-center">
                            © {{date| date:'yyyy'}} ITI Mutual Fund. All rights reserved

                        </div>
                        <div class="">
                            <img class="cursor-pointer" src="assets/icons/bac_ to_top.png" (click)="gotoTop()" />
                        </div>
                    </div>
                    <br><br>
                </div>

            </div>
            <div class="col-lg-2 space-section"></div>

        </div>
    </div>

    <p class="text-center market-risks" [ngStyle]="{'padding-bottom': flag ? '40px' : '0px'}"> Mutual Fund investments
        are subject to market risks, read all scheme related documents carefully. </p>
</div>